import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background: #161616;
  color: #cfcfc7;
  border-top: 2px solid ${({ theme }) => theme.colors.accent};
  padding: 2rem ${({ theme }) => theme.spacing.xl} 1.25rem;
  /* Reserve space on the right so the floating WhatsApp button never covers links */
  padding-right: calc(${({ theme }) => theme.spacing.xl} + 96px);

  @media (max-width: 600px) {
    padding-right: ${({ theme }) => theme.spacing.xl};
  }
`;

export const FooterContent = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

/* ── Top: brand on the left, social on the right ───────────────────── */
export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;

  @media (max-width: 720px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const Brand = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  height: 58px;
  width: auto;

  @media (max-width: 720px) {
    height: 50px;
  }
`;

export const SocialRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: 720px) {
    justify-content: center;
  }
`;

export const SocialIcon = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid rgba(207, 207, 199, 0.3);
  color: #cfcfc7;
  transition: color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  cursor: pointer;

  svg { width: 16px; height: 16px; display: block; }

  &:hover {
    color: #161616;
    background: ${({ theme }) => theme.colors.accent};
    border-color: ${({ theme }) => theme.colors.accent};
    transform: translateY(-2px);
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 1.4rem 0 1.1rem;
`;

/* ── Stacked link rows: navigation above, legal below ──────────────── */
export const LinkSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 0.5rem 1.4rem;
  flex-wrap: wrap;

  &:not(:last-of-type) {
    margin-bottom: 0.85rem;
  }

  @media (max-width: 720px) {
    flex-direction: column;
    align-items: center;
    gap: 0.55rem;
  }
`;

export const LinkGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.45rem 1.3rem;
  align-items: center;
`;

export const FooterLink = styled.a`
  position: relative;
  color: #d4d4cc;
  text-decoration: none;
  font-size: 0.88rem;
  letter-spacing: 0.02em;
  cursor: pointer;
  padding-bottom: 2px;
  background: none;
  border: none;
  font-family: inherit;
  transition: color 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.colors.accent};
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.25s ease;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }

  &:hover::after {
    transform: scaleX(1);
  }
`;

export const LegalLink = styled(FooterLink)`
  font-size: 0.78rem;
  color: #9a9a92;
`;

export const FooterBottom = styled.div`
  margin-top: 1.5rem;
  padding-top: 0.85rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
  color: #7d7d77;
  font-size: 0.74rem;
  letter-spacing: 0.03em;
`;
